(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crews-collection-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('crews-collection-grid')) {
  customElements.define('crews-collection-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      if (!this.cards) {
      this.grid = this.querySelector('[data-main-grid]');
      this.cards = [...this.grid.querySelectorAll('[data-card]')];
      this.seen = new Set(this.cards.map(card => card.dataset.handle));
      this.loadedUrls = new Set();
      this.cards.forEach((card, index) => { card.dataset.feedGroup = 'primary'; card.dataset.feedOrder = index; });
      this.templates = [...this.querySelectorAll('[data-break-template]')];
      this.quotes = [...this.querySelectorAll('[data-quote]')].map(template => template.content.textContent.trim()).filter(Boolean);
      this.breaks = [];
      this.divider = this.querySelector('[data-shop-all-heading]').content.firstElementChild.cloneNode(true);
      this.more = this.querySelector('[data-feed-more]');
      this.moreButton = this.querySelector('[data-load-more]');
      this.status = this.querySelector('[data-feed-status]');
      this.next = this.querySelector('[data-primary-next]')?.getAttribute('href') || '';
      this.source = 'primary';
      this.shopAll = this.dataset.shopAllUrl || '';
      this.filters = { category: 'all', size: '', stock: false };
      this.failed = false;
      this.advanceSource();
      }
      this.addEventListener('click', event => {
        const toggle = event.target.closest('[data-image-toggle]');
        if (toggle) this.toggleFit(toggle);
        if (event.target.closest('[data-load-more]')) {
          this.failed = false;
          if (this.needsFullCatalog()) this.loadAll(); else this.loadNext();
        }
      }, { signal });
      this.addEventListener('submit', event => this.submitHandler(event), { signal });
      this.addEventListener('change', event => this.updatePrice(event), { signal });
      this.addEventListener('pointerover', event => {
        if (event.pointerType === 'mouse') {
          const card = event.target.closest('[data-card]');
          if (card) this.loadFit(card);
        }
      }, { signal });
      const scope = this.closest('main') || document;
      scope.addEventListener('click', event => {
        if (scope.querySelector('crews-collection-grid') !== this) return;
        const toggle = event.target.closest('.cec-look-section [data-image-toggle]');
        if (toggle) this.toggleFit(toggle);
      }, { signal });
      scope.addEventListener('submit', event => {
        if (scope.querySelector('crews-collection-grid') === this && event.target.closest('.cec-look-section')) this.submitHandler(event);
      }, { signal });
      scope.addEventListener('change', event => {
        if (event.target.closest('.cec-look-section')) this.updatePrice(event);
      }, { signal });
      this.dataset.ready = 'true';
      this.querySelector('[data-primary-next]').hidden = true;
      const shopLink = this.querySelector('[data-shop-all-link]');
      if (shopLink) shopLink.hidden = true;
      if ('IntersectionObserver' in window && this.dataset.autoLoad === 'true' && !window.Shopify?.designMode) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting) && !this.failed) this.loadNext();
        }, { rootMargin: '400px' });
      }
      this.handleScroll = () => {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        const schedule = window.requestAnimationFrame || (callback => callback());
        schedule(() => {
          this.scrollTicking = false;
          if (this.dataset.autoLoad !== 'true' || window.Shopify?.designMode || this.loading || !this.next) return;
          if (this.more.getBoundingClientRect().top - window.innerHeight < 600) this.loadNext();
        });
      };
      window.addEventListener('scroll', this.handleScroll, { signal, passive: true });
      this.renderFeed();
      window.dispatchEvent(new CustomEvent('crews:grid-ready', { detail: this }));
      this.setDensity(this.controls?.dataset.defaultDensity || this.dataset.defaultDensity || 'default', false);
      this.observeMore();
      this.handleScroll();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
    get controls() { return (this.closest('main') || document).querySelector('[data-collection-controls]'); }
    hasFilters() { return this.filters.category !== 'all' || !!this.filters.size || this.filters.stock; }
    needsFullCatalog() { return this.filters.category !== 'all' || !!this.filters.size; }
    advanceSource() {
      if (!this.next && this.source === 'primary' && this.shopAll) {
        this.source = 'all';
        this.next = this.shopAll;
        this.shopAll = '';
      }
    }
    observeMore() {
      this.observer?.unobserve(this.more);
      const autoLoading = this.dataset.autoLoad === 'true' && 'IntersectionObserver' in window && !window.Shopify?.designMode;
      this.moreButton.hidden = autoLoading || !this.next;
      this.moreButton.disabled = !!this.loading;
      if (this.next && !this.failed && !this.loading) this.observer?.observe(this.more);
    }
    async loadNext() {
      if (this.loading) return this.loading;
      if (!this.next || !this.controller) return false;
      const controller = this.controller;
      const source = this.source;
      const url = new URL(this.next, location.origin);
      if (url.origin !== location.origin) return false;
      const current = new URL(location.href);
      if (source === 'primary' && current.searchParams.has('sort_by')) url.searchParams.set('sort_by', current.searchParams.get('sort_by'));
      if (current.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
      url.searchParams.delete('section_id');
      const requestKey = url.pathname + url.search;
      this.loadedUrls ||= new Set();
      if (this.loadedUrls.has(requestKey)) {
        this.next = '';
        this.advanceSource();
        this.observeMore();
        return false;
      }
      this.loadedUrls.add(requestKey);
      url.searchParams.set('section_id', this.dataset.sectionId);
      this.observer?.unobserve(this.more);
      this.moreButton.disabled = true;
      this.status.textContent = this.dataset.loadingLabel;
      this.setAttribute('aria-busy', 'true');
      this.loading = (async () => {
        try {
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Page unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = html.querySelector('crews-collection-grid');
          if (!incoming) throw new Error('Grid unavailable');
          const batch = [...incoming.querySelectorAll('[data-main-grid] > [data-card]')];
          for (const card of batch) {
            if (this.seen.has(card.dataset.handle)) continue;
            this.seen.add(card.dataset.handle);
            card.dataset.feedGroup = source === 'primary' ? 'primary' : 'all';
            card.dataset.feedOrder = this.cards.length;
            card.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; img.removeAttribute('fetchpriority'); });
            this.cards.push(card);
          }
          const next = incoming.querySelector('[data-primary-next]')?.getAttribute('href') || '';
          this.next = next ? new URL(next, url).href : '';
          if (this.next) {
            const nextUrl = new URL(this.next, url);
            nextUrl.searchParams.delete('section_id');
            if (nextUrl.pathname + nextUrl.search === requestKey) this.next = '';
          }
          this.advanceSource();
          this.failed = false;
          this.status.textContent = '';
          this.renderFeed(true);
          return true;
        } catch (error) {
          this.loadedUrls.delete(requestKey);
          if (error.name !== 'AbortError') { this.failed = true; this.status.textContent = this.dataset.loadError; }
          return false;
        } finally {
          this.loading = null;
          this.removeAttribute('aria-busy');
          if (this.controller === controller) this.observeMore();
        }
      })();
      return this.loading;
    }
    async loadAll(force = false) {
      if (this.draining) return this.draining;
      this.draining = (async () => {
        while (this.next && this.controller && (force || this.needsFullCatalog())) {
          if (!await this.loadNext()) break;
        }
      })();
      try { await this.draining; } finally { this.draining = null; }
    }
    applyFilters(filters) {
      this.filters = { category: filters.category || 'all', size: filters.size || '', stock: !!filters.stock };
      this.renderFeed();
      if (this.needsFullCatalog()) this.loadAll();
    }
    availableSizes(card) {
      return [...(card.querySelector('[data-size-data]')?.content.querySelectorAll('[data-available-size]') || [])].map(node => node.textContent.trim());
    }
    renderFeed(preserveScroll = false) {
      const stableCard = preserveScroll ? this.cards.find(card => {
        const rect = card.getBoundingClientRect?.();
        return !card.hidden && rect && rect.bottom > 0;
      }) : null;
      const stableTop = stableCard?.getBoundingClientRect().top;
      const filters = this.filters;
      const underLimit = Number(this.controls?.dataset.underLimit || this.dataset.underLimit || 400000);
      this.grid.querySelectorAll('[data-editorial],[data-shop-all-divider]').forEach(node => node.remove());
      this.cards.forEach(card => {
        const categoryMatch = filters.category === 'all' || card.dataset.group === filters.category || (filters.category === 'under' && Number(card.dataset.price) < underLimit);
        card.hidden = !(categoryMatch && (!filters.size || this.availableSizes(card).includes(filters.size)) && (!filters.stock || card.dataset.available === 'true'));
        if (card.parentNode !== this.grid) this.grid.append(card);
      });
      let visible = 0, breakIndex = 0, divided = false;
      const interval = Math.max(1, Number(this.dataset.breakInterval || 8));
      const usedBlocks = new Set();
      for (const card of this.cards) {
        if (card.hidden) continue;
        if (!divided && card.dataset.feedGroup === 'all') { card.before(this.divider); divided = true; }
        visible++;
        if (this.dataset.showEditorial !== 'true' || !this.templates.length) continue;
        const templates = this.dataset.repeatBreaks === 'true'
          ? (visible % interval === 0 ? [this.templates[Math.floor(visible / interval - 1) % this.templates.length]] : [])
          : this.templates.filter(template => Number(template.dataset.position) === visible);
        let anchor = card;
        for (const template of templates) {
          let entry = this.breaks[breakIndex];
          if (!entry || entry.template !== template) {
            entry = { template, node: template.content.firstElementChild.cloneNode(true) };
            if (!template.dataset.blockId && this.quotes.length) {
              const heading = entry.node.querySelector('.cse-editorial-copy h2');
              if (heading) heading.textContent = this.quotes[Math.floor(Math.random() * this.quotes.length)];
            }
            this.breaks[breakIndex] = entry;
          }
          const key = template.dataset.blockId;
          if (key && usedBlocks.has(key)) entry.node.removeAttribute('data-shopify-editor-block');
          else if (key) {
            const attributes = template.content.firstElementChild.getAttribute('data-shopify-editor-block');
            if (attributes) entry.node.setAttribute('data-shopify-editor-block', attributes);
            usedBlocks.add(key);
          }
          if (!key) {
            const breakImage = card.dataset.breakImage || '';
            const image = entry.node.querySelector('[data-auto-break] .cse-editorial-image img');
            if (image && breakImage) { image.src = breakImage; image.removeAttribute('srcset'); }
          }
          anchor.after(entry.node);
          anchor = entry.node;
          breakIndex++;
        }
      }
      this.breaks.length = breakIndex;
      if (stableCard && Number.isFinite(stableTop)) {
        const delta = stableCard.getBoundingClientRect().top - stableTop;
        if (delta) window.scrollBy(0, delta);
      }
      const output = this.querySelector('[data-count]');
      if (output) output.textContent = visible + (this.next ? '+ ' : ' ') + this.dataset.countLabel;
      const empty = this.querySelector('[data-empty]');
      if (empty) empty.hidden = visible > 0 || !!this.next;
      const reset = this.controls?.querySelector('[data-reset]');
      if (reset) reset.hidden = !this.hasFilters();
      const select = this.controls?.querySelector('[data-size]');
      if (select) {
        const known = new Set([...select.options].map(option => option.value));
        for (const card of this.cards) for (const size of this.availableSizes(card)) {
          if (!known.has(size)) { select.add(new Option(size, size)); known.add(size); }
        }
      }
    }
    setDensity(value, persist = true) {
      let density = value === 'compact' ? 'compact' : 'default';
      if (!persist) { try { density = sessionStorage.getItem('crews_grid_v1') || density; } catch {} }
      this.dataset.density = density === 'compact' ? 'compact' : 'default';
      this.controls?.querySelectorAll('button[data-density]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.density === this.dataset.density)));
      if (persist) { try { sessionStorage.setItem('crews_grid_v1', this.dataset.density); } catch {} }
    }
    updatePrice(event) {
      if (!event.target.matches('.cse-sizes input')) return;
      const price = event.target.closest('[data-card]')?.querySelector('[data-card-price]');
      if (price) price.textContent = event.target.dataset.price;
    }
    toggleFit(toggle) {
      const card = toggle.closest('[data-card]');
      if (!card) return;
      const active = card.dataset.fit !== 'true';
      if (active) this.loadFit(card);
      card.dataset.fit = String(active);
      toggle.setAttribute('aria-pressed', String(active));
      toggle.textContent = active ? this.dataset.flatLabel : this.dataset.fitLabel;
    }
    loadFit(card) {
      const template = card.querySelector('[data-fit-template]');
      if (!template) return;
      const image = template.content.firstElementChild.cloneNode(true);
      image.addEventListener('error', () => {
        card.dataset.fit = 'false';
        const toggle = card.querySelector('[data-image-toggle]');
        if (toggle) { toggle.setAttribute('aria-pressed', 'false'); toggle.disabled = true; toggle.textContent = this.dataset.imageError; }
      }, { once: true });
      card.querySelector('.cse-media>a').append(image);
      template.remove();
    }
    async submitHandler(event) {
      const form = event.target;
      if (!form.matches('.cse-product-form')) return;
      event.preventDefault();
      if (form.dataset.busy === 'true' || !form.reportValidity()) return;
      const button = form.querySelector('[type=submit]');
      const original = button.textContent;
      const status = form.querySelector('[data-form-status]');
      const cartLink = form.querySelector('[data-cart-link]');
      const data = new FormData(form);
      const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        data.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
        data.set('sections_url', location.pathname);
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button);
      }
      form.dataset.busy = 'true'; button.disabled = true; button.textContent = this.dataset.adding; status.textContent = ''; cartLink.hidden = true;
      try {
        const response = await fetch(this.dataset.addUrl + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
        const payload = await response.json();
        if (!response.ok || payload.status) { status.textContent = payload.description || this.dataset.error; return; }
        status.textContent = this.dataset.added; cartLink.hidden = false;
        if (drawer && payload.sections && typeof drawer.renderContents === 'function') {
          try { drawer.classList.remove('is-empty'); drawer.renderContents(payload); } catch { location.assign(this.dataset.cartUrl); }
        } else location.assign(this.dataset.cartUrl);
      } catch { status.textContent = this.dataset.error; cartLink.hidden = false; }
      finally { form.dataset.busy = 'false'; button.disabled = false; button.textContent = original; }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crews-collection-intro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('crews-collection-controls')) {
  customElements.define('crews-collection-controls', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const params = new URL(location.href).searchParams;
      this.category = params.get('cec_category') || 'all';
      const size = this.querySelector('[data-size]');
      const selectedSize = params.get('cec_size');
      if (size && selectedSize) {
        if (![...size.options].some(option => option.value === selectedSize)) size.add(new Option(selectedSize, selectedSize));
        size.value = selectedSize;
      }
      const stock = this.querySelector('[data-stock]');
      if (stock) stock.checked = params.get('cec_stock') !== '0';
      this.querySelectorAll('[data-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === this.category)));
      this.addEventListener('click', event => {
        const category = event.target.closest('[data-category]');
        if (category) {
          this.category = category.dataset.category;
          this.querySelectorAll('[data-category]').forEach(button => button.setAttribute('aria-pressed', String(button === category)));
          this.send();
        }
        const density = event.target.closest('button[data-density]');
        if (density) this.grid?.setDensity?.(density.dataset.density);
        if (event.target.closest('[data-reset]')) {
          this.category = 'all';
          if (size) size.value = '';
          if (stock) stock.checked = true;
          this.querySelectorAll('[data-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === 'all')));
          this.send();
        }
      }, { signal });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-size],[data-stock]')) this.send();
        if (event.target.matches('[data-sort]')) {
          const form = event.target.form;
          for (const [name, value] of Object.entries({ cec_category: this.category, cec_size: size?.value || '', cec_stock: stock?.checked ? '1' : '0', preview_theme_id: params.get('preview_theme_id') || '' })) {
            let input = form.querySelector('input[name="' + name + '"]');
            if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
            input.value = value;
          }
          form.requestSubmit();
        }
      }, { signal });
      this.addEventListener('focusin', event => {
        if (event.target.matches('[data-size]')) this.grid?.loadAll?.(true);
      }, { signal });
      window.addEventListener('crews:grid-ready', () => this.send(), { signal });
      this.dataset.ready = 'true';
      this.send();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    get grid() { return (this.closest('main') || document).querySelector('crews-collection-grid'); }
    send() {
      if (!this.grid?.applyFilters) return;
      this.grid.applyFilters({
        category: this.category,
        size: this.querySelector('[data-size]')?.value || '',
        stock: !!this.querySelector('[data-stock]')?.checked
      });
      this.grid.setDensity(this.dataset.defaultDensity || 'default', false);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crews-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('crews-collection-product-grid')) {
  customElements.define('crews-collection-product-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.grid = this.querySelector('[data-main-grid]');
      this.cards = this.grid ? [...this.grid.querySelectorAll('[data-card]')] : [];
      this.category = 'all';
      this.dataset.ready = 'true';
      this.addEventListener('click', event => this.clickHandler(event));
      this.addEventListener('change', event => this.changeHandler(event));
      this.addEventListener('submit', event => this.submitHandler(event));
      this.cards.forEach(card => card.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.loadFit(card); }, { once: true }));
      try { this.setDensity(sessionStorage.getItem('crews_grid_v1') || this.dataset.defaultDensity || 'default'); } catch { this.setDensity(this.dataset.defaultDensity || 'default'); }
      this.filter();
    }
    clickHandler(event) {
      const category = event.target.closest('[data-category]');
      if (category) {
        this.category = category.dataset.category;
        this.querySelectorAll('[data-category]').forEach(button => button.setAttribute('aria-pressed', String(button === category)));
        this.filter();
      }
      const density = event.target.closest('[data-density]');
      if (density) this.setDensity(density.dataset.density);
      const toggle = event.target.closest('[data-image-toggle]');
      if (toggle) {
        const card = toggle.closest('[data-card]');
        const active = card.dataset.fit !== 'true';
        if (active) this.loadFit(card);
        card.dataset.fit = String(active);
        toggle.setAttribute('aria-pressed', String(active));
        toggle.textContent = active ? this.dataset.flatLabel : this.dataset.fitLabel;
      }
      if (event.target.closest('[data-reset]')) {
        const size = this.querySelector('[data-size]');
        const stock = this.querySelector('[data-stock]');
        if (size) size.value = '';
        if (stock) stock.checked = false;
        const all = this.querySelector('[data-category="all"]');
        if (all) all.click(); else { this.category = 'all'; this.filter(); }
      }
    }
    changeHandler(event) {
      if (event.target.matches('[data-size],[data-stock]')) this.filter();
      if (event.target.matches('[data-sort]')) event.target.form.requestSubmit();
      if (event.target.matches('.cse-sizes input')) event.target.closest('[data-card]').querySelector('[data-card-price]').textContent = event.target.dataset.price;
    }
    setDensity(value) {
      const density = value === 'compact' ? 'compact' : 'default';
      this.dataset.density = density;
      this.querySelectorAll('button[data-density]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.density === density)));
      try { sessionStorage.setItem('crews_grid_v1', density); } catch {}
    }
    filter() {
      const sizeInput = this.querySelector('[data-size]');
      const stockInput = this.querySelector('[data-stock]');
      const size = sizeInput ? sizeInput.value : '';
      const stock = stockInput ? stockInput.checked : false;
      const underLimit = Number(this.dataset.underLimit || 400000);
      let count = 0;
      this.cards.forEach(card => {
        const categoryMatch = this.category === 'all' || card.dataset.group === this.category || (this.category === 'under' && Number(card.dataset.price) < underLimit);
        const sizeMatch = !size || [...card.querySelectorAll('.cse-sizes input:not(:disabled)')].some(input => input.nextElementSibling.textContent.trim() === size);
        const show = categoryMatch && sizeMatch && (!stock || card.dataset.available === 'true');
        card.hidden = !show;
        if (show) count++;
      });
      this.querySelectorAll('[data-editorial]').forEach(editorial => { editorial.hidden = this.category !== 'all' || !!size || stock; });
      const countOutput = this.querySelector('[data-count]');
      if (countOutput) countOutput.textContent = count + ' ' + this.dataset.countLabel;
      const empty = this.querySelector('[data-empty]');
      if (empty) empty.hidden = count > 0;
      const reset = this.querySelector('[data-reset]');
      if (reset) reset.hidden = this.category === 'all' && !size && !stock;
    }
    loadFit(card) {
      const template = card.querySelector('[data-fit-template]');
      if (!template) return;
      const image = template.content.firstElementChild.cloneNode(true);
      image.addEventListener('error', () => {
        card.dataset.fit = 'false';
        const toggle = card.querySelector('[data-image-toggle]');
        if (toggle) { toggle.setAttribute('aria-pressed', 'false'); toggle.textContent = this.dataset.imageError; toggle.disabled = true; }
      }, { once: true });
      card.querySelector('.cse-media>a').append(image);
      template.remove();
    }
    async submitHandler(event) {
      const form = event.target;
      if (!form.matches('.cse-product-form')) return;
      event.preventDefault();
      if (form.dataset.busy === 'true' || !form.reportValidity()) return;
      const button = form.querySelector('[type=submit]');
      const original = button.textContent;
      const status = form.querySelector('[data-form-status]');
      const cartLink = form.querySelector('[data-cart-link]');
      const data = new FormData(form);
      const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (drawer && typeof drawer.getSectionsToRender === 'function') { data.set('sections', drawer.getSectionsToRender().map(section => section.id).join(',')); data.set('sections_url', window.location.pathname); if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button); }
      form.dataset.busy = 'true'; button.disabled = true; button.textContent = this.dataset.adding; status.textContent = ''; cartLink.hidden = true;
      try {
        const response = await fetch(this.dataset.addUrl + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
        const payload = await response.json();
        if (!response.ok || payload.status) { status.textContent = payload.description || this.dataset.error; return; }
        status.textContent = this.dataset.added; cartLink.hidden = false;
        if (drawer && payload.sections && typeof drawer.renderContents === 'function') { try { drawer.classList.remove('is-empty'); drawer.renderContents(payload); } catch { window.location.assign(this.dataset.cartUrl); } } else window.location.assign(this.dataset.cartUrl);
      } catch { status.textContent = this.dataset.error; cartLink.hidden = false; }
      finally { form.dataset.busy = 'false'; button.disabled = false; button.textContent = original; }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crews-soft-errors"]) return;
  try {
    
if (!customElements.get('crews-soft-errors')) {
  customElements.define('crews-soft-errors', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.grid = this.querySelector('[data-main-grid]');
      this.cards = [...this.grid.querySelectorAll('[data-card]')];
      this.category = 'all';
      this.dataset.ready = 'true';
      this.addEventListener('click', event => this.clickHandler(event));
      this.addEventListener('change', event => this.changeHandler(event));
      this.addEventListener('submit', event => this.submitHandler(event));
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const details = event.target.closest('.cse-quick');
          if (details) { details.open = false; details.querySelector('summary').focus(); }
        }
      });
      this.cards.forEach(card => card.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') this.loadFit(card);
      }, { once: true }));
      try { this.setDensity(sessionStorage.getItem('crews_grid_v1') || 'default'); } catch {}
      this.renderRecent();
      this.filter();
      window.addEventListener('pageshow', () => this.renderRecent());
    }
    clickHandler(event) {
      const jump = event.target.closest('[data-jump]');
      if (jump) {
        const target = this.querySelector(`[data-group-section="${jump.dataset.jump}"]`);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      const category = event.target.closest('[data-category]');
      if (category) {
        this.category = category.dataset.category;
        this.querySelectorAll('[data-category]').forEach(b => b.setAttribute('aria-pressed', String(b === category)));
        this.filter();
      }
      const density = event.target.closest('[data-density]');
      if (density && density !== this) this.setDensity(density.dataset.density);
      const toggle = event.target.closest('[data-image-toggle]');
      if (toggle) {
        const card = toggle.closest('[data-card]');
        const active = card.dataset.fit !== 'true';
        if (active) this.loadFit(card);
        card.dataset.fit = String(active);
        toggle.setAttribute('aria-pressed', String(active));
        toggle.textContent = active ? this.dataset.flatLabel : this.dataset.fitLabel;
      }
      if (event.target.closest('[data-reset]')) {
        this.querySelector('[data-size]').value = '';
        this.querySelector('[data-stock]').checked = false;
        this.querySelector('[data-category="all"]').click();
      }
    }
    changeHandler(event) {
      if (event.target.matches('[data-size],[data-stock]')) this.filter();
      if (event.target.matches('[data-sort]')) event.target.form.requestSubmit();
      if (event.target.matches('.cse-sizes input')) {
        event.target.closest('[data-card]').querySelector('[data-card-price]').textContent = event.target.dataset.price;
      }
    }
    setDensity(value) {
      const density = value === 'compact' ? 'compact' : 'default';
      this.dataset.density = density;
      this.querySelectorAll('button[data-density]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.density === density)));
      try { sessionStorage.setItem('crews_grid_v1', density); } catch {}
    }
    filter() {
      const size = this.querySelector('[data-size]').value;
      const stock = this.querySelector('[data-stock]').checked;
      let count = 0;
      this.cards.forEach(card => {
        const categoryMatch = this.category === 'all' || card.dataset.group === this.category || (this.category === 'under' && Number(card.dataset.price) < 400000);
        const sizeMatch = !size || [...card.querySelectorAll('.cse-sizes input:not(:disabled)')].some(input => input.nextElementSibling.textContent.trim() === size);
        const show = categoryMatch && sizeMatch && (!stock || card.dataset.available === 'true');
        card.hidden = !show;
        if (show) count++;
      });
      this.querySelectorAll('[data-editorial]').forEach(editorial => {
        editorial.hidden = this.category !== 'all' || !!size || stock;
      });
      this.querySelector('[data-count]').textContent = count + ' ' + this.dataset.countLabel;
      this.querySelector('[data-empty]').hidden = count > 0;
      this.querySelector('[data-reset]').hidden = this.category === 'all' && !size && !stock;
      this.updateGroupHeadings();
    }
    updateGroupHeadings() {
      this.querySelectorAll('[data-group-section]').forEach(heading => {
        let node = heading.nextElementSibling;
        let visible = false;
        while (node && !node.matches('[data-group-section]')) {
          if (node.matches('[data-card]') && !node.hidden) visible = true;
          node = node.nextElementSibling;
        }
        heading.hidden = !visible;
      });
    }
    loadFit(card) {
      const template = card.querySelector('[data-fit-template]');
      if (!template) return;
      const image = template.content.firstElementChild.cloneNode(true);
      image.addEventListener('error', () => {
        card.dataset.fit = 'false';
        const toggle = card.querySelector('[data-image-toggle]');
        toggle.setAttribute('aria-pressed', 'false');
        toggle.textContent = this.dataset.imageError;
        toggle.disabled = true;
      }, { once: true });
      card.querySelector('.cse-media>a').append(image);
      template.remove();
    }
    async submitHandler(event) {
      const form = event.target;
      if (!form.matches('.cse-product-form')) return;
      event.preventDefault();
      if (form.dataset.busy === 'true' || !form.reportValidity()) return;
      const button = form.querySelector('[type=submit]');
      const original = button.textContent;
      const status = form.querySelector('[data-form-status]');
      const cartLink = form.querySelector('[data-cart-link]');
      const data = new FormData(form);
      const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        data.set('sections', drawer.getSectionsToRender().map(s => s.id).join(','));
        data.set('sections_url', window.location.pathname);
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button);
      }
      form.dataset.busy = 'true';
      button.disabled = true;
      button.textContent = this.dataset.adding;
      status.textContent = '';
      cartLink.hidden = true;
      try {
        const response = await fetch(this.dataset.addUrl + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
        const payload = await response.json();
        if (!response.ok || payload.status) {
          status.textContent = payload.description || this.dataset.error;
          return;
        }
        status.textContent = this.dataset.added;
        cartLink.hidden = false;
        if (drawer && payload.sections && typeof drawer.renderContents === 'function') {
          try {
            drawer.classList.remove('is-empty');
            drawer.renderContents(payload);
          } catch {
            window.location.assign(this.dataset.cartUrl);
          }
        } else {
          window.location.assign(this.dataset.cartUrl);
        }
      } catch {
        status.textContent = this.dataset.error;
        cartLink.hidden = false;
      } finally {
        form.dataset.busy = 'false';
        button.disabled = false;
        button.textContent = original;
      }
    }
    renderRecent() {
      const host = this.querySelector('[data-recent-grid]');
      host.replaceChildren();
      try {
        const recent = JSON.parse(sessionStorage.getItem('crews_recent_v1') || '[]');
        if (!Array.isArray(recent)) return;
        recent.slice(0,8).forEach(handle => {
          const card = this.cards.find(c => c.dataset.handle === handle);
          if (!card || host.children.length >= 4) return;
          const link = document.createElement('a');
          const source = card.querySelector('h2 a');
          link.href = source.href;
          const img = card.querySelector('.cse-flat').cloneNode(true);
          img.loading = 'lazy';
          const label = document.createElement('span');
          label.textContent = source.textContent;
          link.append(img, label);
          host.append(link);
        });
      } catch {}
      this.querySelector('[data-recent-section]').hidden = !host.children.length;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
